import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw9000Handlers = [
  // KYMW9000 ユーザ一覧
  http.post(
    PlessService.SERVICE.getAssociatedUserManagementList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getAssociatedUserManagementList);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
  http.post(
    PlessService.SERVICE.getAssociatedUserType.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getAssociatedUserType);
    }
  ),
  http.post(
    PlessService.SERVICE.deleteAssociatedUserManagement.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(deleteAssociatedUserManagement);
    }
  ),
];

const getAssociatedUserManagementList = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      TotalNum: 10,
      StartDispNum: 5,
      EndDispNum: 10,
      AssociatedUserList: [
        {
          AssociatedUserId: "00000001",
          AssociatedUserType: "1",
          AssociatedUserTypeName: "取引先(卸)",
          AssociatedUserName: "取引太郎",
          EmailAddress: "torihiki.tarou@xxx.co.jp",
          AuthoritySetId: "00",
          AuthoritySetName: "管理者",
          AssociatedCompanyId: "000001",
          AssociatedCompanyName: "AAA取引先",
          IsEnabled: "0",
        },
        {
          AssociatedUserId: "00000002",
          AssociatedUserType: "2",
          AssociatedUserTypeName: "髙、﨑、😀",
          AssociatedUserName: "髙、﨑、😀",
          EmailAddress: "seisaku.jirou@xxx.co.jp",
          AuthoritySetId: "01",
          AuthoritySetName: "髙、﨑、😀",
          AssociatedCompanyId: "000002",
          AssociatedCompanyName: "髙、﨑、😀",
          IsEnabled: "1",
        },
        {
          AssociatedUserId: "00000003",
          AssociatedUserType: "1",
          AssociatedUserTypeName: "",
          AssociatedUserName: "",
          EmailAddress: "",
          AuthoritySetId: "00",
          AuthoritySetName: "",
          AssociatedCompanyId: "000001",
          AssociatedCompanyName: "AAA",
          IsEnabled: "0",
        },
        {
          AssociatedUserId: "00000004",
          AssociatedUserType: "3",
          AssociatedUserTypeName: "制作会社",
          AssociatedUserName: "制作次郎",
          EmailAddress: "seisaku.jirou@xxx.co.jp",
          AuthoritySetId: "01",
          AuthoritySetName: "一般ユーザ",
          AssociatedCompanyId: "000002",
          AssociatedCompanyName: "BBB制作会社",
          IsEnabled: "1",
        },
      ]
    }
  }
};

const getAssociatedUserType = {
  status: "ok",
  message: "処理終了",
  result: {
    obj: {
      AssociatedUserTypeList: [
        {
          AssociatedUserType: "1",
          AssociatedUserTypeName: "取引先(卸)"
        },
        {
          AssociatedUserType: "3",
          AssociatedUserTypeName: "制作会社"
        },
        {
          AssociatedUserType: "2",
          AssociatedUserTypeName: "スタジオ"
        }
      ]
    }
  }
}

const deleteAssociatedUserManagement = {
  status: "ok",
  message: "処理完了"
};